import React from 'react';

const LightningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.2}
      d="M14.5 3 5.5 12.5h5.1L9.7 21l8.8-9.5h-5.1L14.5 3Z"
    />
  </svg>
);

export default LightningIcon;
